import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import { useContent } from '../hooks/useContent';
import { useScrollToTop } from '../hooks/useScrollToTop';

const OtherProducts = () => {
  useScrollToTop();
  const { otherProducts } = useContent();

  return (
    <SimplePage
      title={otherProducts.title}
      description={otherProducts.description}
    />
  );
};

export default OtherProducts;